export default "__VITE_ASSET__DJ$PXRma__"